export default function formatFirstName(firstName: string) {
    return firstName
        .replaceAll('-', ' - ')
        .split(' ')
        .filter((str: string) => str !== '')
        .map((str: string) => str[0].toUpperCase() + str.slice(1).toLowerCase())
        .join(' ');
}
